import React from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import img from '../img/image.png'
import Container from '@mui/material/Container';
import Markdown from 'react-markdown';


function Career({content}) {
    const API_URL = process.env.REACT_APP_STRAPI_URL || 'http://81.31.246.97:1337';
    
    return (
        <div >
            <Container>
                <Typography gutterBottom variant="h4" component="div" className='block_title'>
                    {content?.title || ''}
                </Typography>
                <Grid container spacing={2} sx={{justifyContent: { xs: 'center', xl: 'start' } }}>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Typography className='mainText' component="div">
                            <Markdown>{content?.text || ''}</Markdown>
                        </Typography>
                        <a className='href' href='https://spb.hh.ru/search/vacancy?text=%D0%BA%D0%BE%D0%BD%D1%82%D1%83%D1%80+%D0%BD%D0%B8%D0%B8%D1%80%D1%81&area=2&hhtmFrom=main&hhtmFromLabel=vacancy_search_line'>{(content?.someText?.[0].body) || ''}</a>
                        <br></br>
                        <a className='href' href='/sawc'>{(content?.someText?.[1].body) || ''}</a>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }} ><img alt='img' width='500px' className='mainPageImg'  src={content?.images ? API_URL+content.images[0].url : img}></img></Grid>
                </Grid>
            </Container>
        </div>
    );
}
export default Career;
